




































import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { viewData, NotificationFormData } from '@/api/systemManage/notification'
import ViewDialog from '@/components/dialog/viewDialog.vue'

@Component({
  components: {
    ViewDialog
  }
})
export default class NotificationView extends Vue {
  public showDialog: boolean = false
  public loading: boolean = false

  public form: NotificationFormData = {
    Title: '',
    Notification: '',
    PublishUnit: ''
  }
  public $refs!: {}
  public created() { }
  public mounted() {
    window.eventBus.$on("viewNotification", (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("viewNotification")
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    viewData(id)
      .then((response: { data: any }) => {
        this.form = response.data
        this.loading = false
      })
      .catch((error: any) => {
        console.log(error)
      })
  }
}
